import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InAppNotificationsState } from 'src/app/in-app-notifications/store/in-app-notifications.state';

export const inAppNotificationsFeatureKey = 'inAppNotifications';
export const inAppNotificationsFeature = createFeatureSelector<InAppNotificationsState>(inAppNotificationsFeatureKey);

export const selectLoading = createSelector(inAppNotificationsFeature, (state) => state.loading);
export const selectFilter = createSelector(inAppNotificationsFeature, (state) => state.filter);
export const selectInAppNotifications = createSelector(inAppNotificationsFeature, (state) => state.inAppNotifications);
export const selectUnreadInAppNotificationCounts = createSelector(
    inAppNotificationsFeature,
    (state) => state.unreadInAppNotificationCounts
);
export const selectUnreadInAppNotificationCountsForDelegation = createSelector(
    inAppNotificationsFeature,
    (state) => state.unreadInAppNotificationCountsForDelegation
);
export const selectUnreadInAppNotificationsTabCounters = createSelector(
    inAppNotificationsFeature,
    (state) => state.unreadInAppNotificationsTabCounters
);
export const selectInAppNotificationSentAlert = createSelector(
    inAppNotificationsFeature,
    (state) => state.inAppNotificationSentAlert
);
export const selectHasOverdueTasksCreatedByMe = createSelector(
    inAppNotificationsFeature,
    (state) => state.hasOverdueTasksCreatedByMe
);
export const selectInAppNotificationsUser = createSelector(inAppNotificationsFeature, (state) => state.user);
